import React from 'react';
export function StickyMobileBar() {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-alt bg-base/95 px-4 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] backdrop-blur md:hidden" data-id="element-269" data-mp="162sfolk8bhyb">
      <div className="flex items-center justify-between gap-3" data-id="element-270" data-mp="276a1lb80mkma">
        <div className="leading-tight" data-id="element-271" data-mp="226xecpd8fbj6">
          <p className="text-xs text-strike line-through" data-id="element-272" data-mp="227ypetu8zy0w">OFERTA</p>
          <p className="text-lg font-black text-ink" data-id="element-273" data-mp="1eh332c8k9v11">ESPECIAL</p>
        </div>
        <a href="#precio" className="flex-1 rounded-xl bg-accent px-3 py-3 text-center text-xs font-bold text-white transition-all hover:bg-accent-dark active:scale-[0.98]" data-id="element-274" data-mp="1ej62tnzin2iy">
          → QUIERO BLINDAR MI ESTUDIO 
        </a>
      </div>
    </div>;
}